// extracted by mini-css-extract-plugin
export var bold = "_y7-0";